/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiConversationCategory,
    BridgeApiConversationCategoryFromJSON,
    BridgeApiConversationCategoryToJSON,
} from '../models';

export interface GetPossibleCategoriesForSendingRfiRequest {
    recipientOrganisationId: string;
}

/**
 * 
 */
export class BridgeConversationCategoryApi extends runtime.BaseAPI {

    /**
     * Get all categories configured for the organisation
     */
    async getConversationCategoriesForOrganisationRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<BridgeApiConversationCategory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BridgeApiConversationCategoryFromJSON));
    }

    /**
     * Get all categories configured for the organisation
     */
    async getConversationCategoriesForOrganisation(initOverrides?: RequestInit): Promise<Array<BridgeApiConversationCategory>> {
        const response = await this.getConversationCategoriesForOrganisationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all categories in common with recipient organisation
     */
    async getPossibleCategoriesForSendingRfiRaw(requestParameters: GetPossibleCategoriesForSendingRfiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<BridgeApiConversationCategory>>> {
        if (requestParameters.recipientOrganisationId === null || requestParameters.recipientOrganisationId === undefined) {
            throw new runtime.RequiredError('recipientOrganisationId','Required parameter requestParameters.recipientOrganisationId was null or undefined when calling getPossibleCategoriesForSendingRfi.');
        }

        const queryParameters: any = {};

        if (requestParameters.recipientOrganisationId !== undefined) {
            queryParameters['recipientOrganisationId'] = requestParameters.recipientOrganisationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/categories/organisation-recipient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BridgeApiConversationCategoryFromJSON));
    }

    /**
     * Get all categories in common with recipient organisation
     */
    async getPossibleCategoriesForSendingRfi(requestParameters: GetPossibleCategoriesForSendingRfiRequest, initOverrides?: RequestInit): Promise<Array<BridgeApiConversationCategory>> {
        const response = await this.getPossibleCategoriesForSendingRfiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
